import { ImageHotspotsPrintView } from '@apps/image-hotspots';
import { defaultPm2PrintChunkClassName } from '@provider/print';
import { jsx } from 'react/jsx-runtime';

const printImageHotspotsComponentPaper = node => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(ImageHotspotsPrintView, {
      component: node.component
    })
  }];
};
const imageHotspotsComponentPaperPrinters = {
  "component-framework.image-hotspots": printImageHotspotsComponentPaper
};

export { imageHotspotsComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
